import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./pages/home/HomePage";
import AnalysisPage from "./pages/analisys/AnalysisPage";
import NotFound from "./pages/notfound/NotFound";
import "./App.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/analysis",
    element: <AnalysisPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

function App() {
  return (
    <div className="app-shell">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
